module.exports = __webpack_public_path__ + "img/lagoon.5497870b.png";